import { useMsal } from '@azure/msal-react'
import { useEffect, PropsWithChildren, useState } from 'react'

// const apiInstances = [colliderApi] /* ===The collidr Api is not in use in decoupling apps, will be considered in future *===/

export const ApiProvider = ({ children }: PropsWithChildren<{}>) => {
  const { instance, accounts } = useMsal()

  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    setIsReady(true)

    /*== commmenting token code, as no API call is used ===*/
    // if (accounts.length === 0) return

    // const account = accounts[0]

    // // Shared token getter — acquireTokenSilent handles refresh automatically
    // // replaces both osApi.getAccessToken() and useAZToken() entirely
    // const getMsalToken = async (): Promise<string> => {
    //   try {
    //     const response = await instance.acquireTokenSilent({ ...loginRequest, account })
    //     return response.accessToken
    //   } catch (error) {
    //     if (error instanceof InteractionRequiredAuthError) {
    //       window.location.href = `${process.env.REACT_APP_ROOT_URL}/login`
    //     }
    //     return ''
    //   }
    // }

    // const apiInstances = [colliderApi] /* ===The collider Api is not in use in decoupling apps, will be considered in future *===/
    // apiInstances.forEach(instance => {
    //   instance.client.interceptors.request.use(
    //    async config => {
    //       const token = await getMsalToken()
    //       if(token) {
    //         config!.headers!.Authorization = `Bearer ${token}`
    //         config!.headers!['X-Tenant-Id'] = process.env.REACT_APP_X_TENANT_ID ?? '',
    //       }
    //       return config
    //     },
    //     error => Promise.reject(error),
    //   )

    //   instance.client.interceptors.response.use(
    //     response => response,
    //     error => Promise.reject(error),
    //   )
    // })

    setIsReady(true)
  }, [instance, accounts])

  return <>{isReady && <>{children}</>}</>
}
